module.exports = __webpack_public_path__ + "img/img-recordar.a1b42103.svg";